import "./ListingDescription.css";

const ListingDescription = ({ listing, currentLang }) => {
  if (!listing) return null;

  const attributes = listing.attributes || {}
  const publicData = attributes.publicData || {};

  console.log(listing)
  const description = currentLang === "en"?(attributes['description'] || ''):(publicData[`description_${currentLang}`]||attributes['description'])

  return <p className="listing-description">{description}</p>;
};

export default ListingDescription
